import { Space } from '@tribeplatform/gql-client/types'
import { SpaceImage } from '@tribeplatform/react-components/Space'
import { useRouter, useRouterPath } from '@tribeplatform/react-sdk'
import { useSpaceUtil } from '@tribeplatform/react-sdk/hooks'
import { NavVertical } from '@tribeplatform/react-ui-kit/Sidebar'

import { useSlate } from '../../hooks/slate.hook.js'
import { useMobileMenu } from '../Navbar/providers/MobileMenuProvider.js'

export const CollectionMenuSpaceItem = ({ space }: { space: Space }) => {
  const { Link } = useRouter()
  const { close } = useMobileMenu()
  const { matchPath } = useSpaceUtil()
  const pathname = useRouterPath()
  const { mode } = useSlate()
  const isPreviewMode = mode !== 'live'
  const isActive = matchPath(space, pathname)

  return (
    <NavVertical.Item
      as={Link}
      href={space?.relativeUrl}
      active={!!isActive}
      leadingAddon={
        <div className="me-3 -ms-1">
          <SpaceImage space={space} size="lg" />
        </div>
      }
      onClick={e => {
        if (isPreviewMode) {
          e.preventDefault()
          return
        }

        close()
      }}
    >
      {space.name}
    </NavVertical.Item>
  )
}
